export default "__VITE_ASSET__$B1D8lKa__"